exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-727f001e] th{padding:0 3px!important}", ""]);

// exports
